import React, { useEffect, useState } from 'react';
import "../../css/navbar.css";
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { debounce } from '../../utilities/helpers';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
// import YouTubeIcon from '@mui/icons-material/YouTube';

const Navbar = () => {


  const [prevScrollPos, setPrevScrollPos] = useState(0);

  const [visible, setVisible] = useState(true);


  const handleScroll = debounce(() => {
    const currentScrollPos = window.scrollY;

    setVisible((prevScrollPos > currentScrollPos && prevScrollPos - currentScrollPos > 90) || currentScrollPos < 20);

    setPrevScrollPos(currentScrollPos);
  }, 100);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);

  }, [prevScrollPos, visible, handleScroll]);


  return (
    <>
      {/* Maybe swap out navbar on scroll? */}

      <nav className='navbar' id="navbar" style={{ top: visible ? '0' : '-90px' }}>
        {/* <nav className={visible ? 'navbar colorChange' : 'navbar'} id="navbar" style={{ top: visible ? '0' : '-90px' }}> */}

        <div className="social-icons-main">
          {/* <Link to="/signin" className="sign-in">Login</Link> */}
          <a href="https://twitter.com" rel="noopener" target="_blank"><TwitterIcon /></a>
          <a href="https://instagram.com" rel="noopener" target="_blank"><InstagramIcon /></a>
          {/* <YouTubeIcon /> */}

          {/* <Link to="/register" className="register">Create Account</Link> */}
        </div>

        <ul className="nav-links">
          <div className="menu">
            <li><a href="#about">About</a></li>
            <li><a href="">Features</a></li>
            <div>
              <img className='logo-white' src="./logo.png" alt="Driveplus logo" width="225px" />
              <img className='logo-black' src="./logo_black.png" alt="Driveplus logo" width="225px" />
            </div>
            <li><a href="#pricing">Pricing</a></li>
            <li><a href="">Contact</a></li>
          </div>
        </ul>

        <div className="menu-icon dropdown">
          <a href="" className="dropbtn"><AccountCircleIcon fontSize='large' /></a>

          <div className="dropdown-content">
            <Link to="/login">Login</Link>
            <Link to="/register">Create Account</Link>
          </div>
          {/* <Link to="/login" className="sign-in">Login</Link> */}
          {/* <Link to="/register" className="register">Create Account</Link> */}
        </div>

      </nav>

    </>
  )
}

export default Navbar